import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { formatGameTime } from "../format/formatGameTime";
import { formatList } from "../format/formatList";
import { formatPercent } from "../format/formatPercent";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";
import { KillerCounter } from "./KillerCounter";

const TITLE = msg({
  id: "finding.killed_by_hero",
  message: "{hero} killed you {deaths, plural, one {# time} other {# times}}",
});

const DETAILS = msg({
  id: "finding.killed_by_hero.details",
  message:
    "That is {deaths} of your {totalDeaths, plural, one {# death} other {# deaths}}. They dealt {damageShare} of the hero damage you took. Deaths at {times}.",
});

const SUMMARY = msg({
  id: "finding.killed_by_hero.summary",
  message: "{deaths} of your {totalDeaths, plural, one {# death} other {# deaths}}",
});

// Один и тот же вражеский герой убивает игрока снова и снова.
export const KilledByHero = ({ finding, variant }: FindingProps<"killed_by_hero">) => {
  const { i18n } = useLingui();
  const hero = useAssetLookup("heroes")(finding.params.hero_id);
  const { deaths, total_deaths: totalDeaths, damage_share, death_times_s } = finding.params;
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={hero} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { hero: hero.name, deaths } })}
      details={i18n._({
        ...DETAILS,
        values: {
          deaths,
          totalDeaths,
          damageShare: formatPercent(damage_share, i18n.locale),
          times: formatList(death_times_s.map(formatGameTime), i18n.locale),
        },
      })}
      summary={i18n._({ ...SUMMARY, values: { deaths, totalDeaths } })}
    >
      <KillerCounter finding={finding} className="mt-1 text-xs text-subtle" />
    </FindingCard>
  );
};
